import React from 'react'
import { Box } from '@mui/material'
import SearchBarInput from '../master/components/SearchBarInput';
import MasterAppBar from '../master/components/MasterAppBar'
import Events from '../dashbord/components/Events';
import Footer from '../master/components/Footer';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';

function MyEvents() {
    return (
        <ScopedCssBaseline>
            <Box>
                <MasterAppBar crumb={true} />
                <SearchBarInput />
                <Box sx={{ width: 'min(1100px, 92vw)', mx: 'auto', my: 4 }}><Events /></Box>
                <Footer />
            </Box>
        </ScopedCssBaseline>

    )
}

export default MyEvents
